import React from 'react';
import classNames from 'classnames';
interface IProps {
  fillId: string,
  changeRating?: (e: any)=>void,
  hoverOverStar?: (e: any)=>void,
  unHoverOverStar?: (e: any)=>void,
  isStarred: boolean,
  isPartiallyFullStar: boolean,
  isHovered: boolean,
  hoverMode: boolean,
  isCurrentHoveredStar: boolean,
  isFirstStar: boolean,
  isLastStar: boolean,
  starDimension: string,
  starSpacing: string,
  starHoverColor: string,
  starRatedColor: string,
  starEmptyColor: string,
  gradientPathName: string,
  ignoreInlineStyles: boolean,
  svgIconPath: string,
  svgIconViewBox: string,
  disabled?: boolean
}
class Star extends React.Component<IProps> {

  get starContainerStyle() {
    const {
      changeRating,
      starSpacing,
      isFirstStar,
      isLastStar,
      ignoreInlineStyles,
      disabled
    } = this.props;

    const starContainerStyle = {
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'middle',
      paddingLeft: isFirstStar ? undefined : starSpacing,
      paddingRight: isLastStar ? undefined : starSpacing,
      cursor: changeRating && !disabled ? 'pointer' : undefined
    };
    return ignoreInlineStyles ? {} : starContainerStyle
  }

  get starSvgStyle() {
    const {
      ignoreInlineStyles,
      isCurrentHoveredStar,
      starDimension
    } = this.props;
    const starSvgStyle = {
      width: starDimension,
      height: starDimension,
      transition: 'transform .2s ease-in-out',
      transform: isCurrentHoveredStar ? 'scale(1.1)' : undefined
    };

    return ignoreInlineStyles ? {} : starSvgStyle;
  }

  get pathStyle() {
    const {
      isStarred,
      isPartiallyFullStar,
      isHovered,
      hoverMode,
      starEmptyColor,
      starRatedColor,
      starHoverColor,
      gradientPathName,
      fillId,
      ignoreInlineStyles
    } = this.props;

    let fill;
    if (hoverMode) {
      if (isHovered) fill = starHoverColor;
      else fill = starEmptyColor;
    } else {
      if (isPartiallyFullStar) fill = `url('${gradientPathName}#${fillId}')`;
      else if (isStarred) fill = starRatedColor;
      else fill = starEmptyColor;
    }

    const pathStyle = {
      fill: fill,
      transition: 'fill .2s ease-in-out',
    };

    return ignoreInlineStyles ? {} : pathStyle;
  }

  get starClasses() {
    const {
      // isSelected,
      isPartiallyFullStar,
      isHovered,
      isCurrentHoveredStar,
      ignoreInlineStyles
    } = this.props;

    const starClasses = classNames({
      'widget-svg': true,
      // 'widget-selected': isSelected,
      'multi-widget-selected': isPartiallyFullStar,
      'hovered': isHovered,
      'current-hovered': isCurrentHoveredStar
    })

    return ignoreInlineStyles ? {} : starClasses
  }

  render() {
    const {
      changeRating,
      hoverOverStar,
      unHoverOverStar,
      svgIconViewBox,
      svgIconPath
    } = this.props;
    return (
      <div
        className="star-container"
        style={this.starContainerStyle}
        onMouseEnter={hoverOverStar}
        onMouseLeave={unHoverOverStar}
        onClick={changeRating}
      >
        <svg
          viewBox={svgIconViewBox}
          className={this.starClasses as any}
          style={this.starSvgStyle}
        >
          <path
            className="star"
            style={this.pathStyle}
            d={svgIconPath}
          />
        </svg>
      </div>
    );
  }
}

export default Star;